"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormulaFieldValueGetter = void 0;
const base_calculated_fieldtype_1 = require("../base-calculated.fieldtype");
class FormulaFieldValueGetter extends base_calculated_fieldtype_1.BaseCalculatedFieldValueGetter {
    constructor() {
        super(...arguments);
        this.isValidFieldValue = (fieldValue) => {
            // TODO: check all formula types (string, number, date...)
            return fieldValue !== undefined;
        };
        this.getEmptyValue = () => null;
    }
}
exports.FormulaFieldValueGetter = FormulaFieldValueGetter;
